<div class="container">
  <section class="main">
    <header class="header">
      <mat-icon>donut_large</mat-icon><span>AI Sales Coach</span>
    </header>
    <div class="content">
      <h1>多要素認証の登録方法</h1>
      <p>ログインに使用する認証方法を登録してください。</p>
      @for (method of methods; track method) {
        <button rectangle (click)="select(method)">
          {{
            method === 'PASSKEY'
              ? 'パスキー'
              : method === 'SMS'
                ? 'SMS'
                : '認証アプリ (Authenticator)'
          }}
        </button>
      }
      <button
        rectangle
        variant="secondary"
        [disabled]="false"
        (click)="backToLogin()"
      >
        ログインへ戻る
      </button>
    </div>
  </section>
</div>
